import AboutCapitalAcres from "./components/AboutCapitalAcres";
import AboutDeveloper from "./components/AboutDeveloper";
import BestQuotes from "./components/BestQuotes";
import Details from "./components/Details";
import FloorPlan from "./components/FloorPlan";
import Footer from "./components/Footer";
import Form from "./components/Form";
import Header from "./components/Header";
import Hero from "./components/Hero";
import NewForm from "./components/NewForm";
import Pricing from "./components/Pricing";
import Slider from "./components/Slider";

import StripSection from "./components/StripSection";

function App(){

  const project = "Dosti Greenscapes Pune"

  const galleryImages = [
    {
      src: "images/gallary1.jpg",
      alt: "gallery1",
      title: "gallery1",
    },
    {
      src: "images/gallary2.jpg",
      alt: "gallery2",
      title: "gallery2",
    },
    {
      src: "images/gallary3.jpg",
      alt: "gallery3",
      title: "gallery3",
    },
    {
      src: "images/gallary4.jpg",
      alt: "gallery4",
      title: "gallery4",
    },
    {
      src: "images/gallary5.jpg",
      alt: "gallery5",
      title: "gallery5",
    },
    {
      src: "images/gallary6.jpg",
      alt: "gallery6",
      title: "gallery6",
    }
    // Add more amenities as needed
  ];
  const amenityImages = [
    {
      src: "images/barbeque.jpg",
      alt: "barbeque",
      title: "barbeque",
    },
    {
      src: "images/gym.jpg",
      alt: "gym",
      title: "gym",
    },
    {
      src: "images/jogging.jpg",
      alt: "jogging",
      title: "jogging",
    },
    {
      src: "images/kids play area.jpg",
      alt: "kids play area",
      title: "kids play area",
    },
    {
      src: "images/pool.jpg",
      alt: "pool",
      title: "pool",
    },
    {
      src: "images/yoga.jpg",
      alt: "yoga",
      title: "yoga",
    }
    // Add more amenities as needed
  ];
  return(
    <>
    
    <div className="App">
      <Header />
      <Hero />
      <StripSection/>
      <NewForm />
      <Details project={project} />
      <Pricing project={project}/>
      <FloorPlan project={project}/>
      <Slider project={project} title="Amenities" images={amenityImages} />
      <Slider project={project} title="Gallery" images={galleryImages} />
      <AboutDeveloper project={project}/>
      <AboutCapitalAcres />
      <BestQuotes />
      <Footer />
      <Form />
    </div>
    </>
  )
}

export default App;
